import EllipsisVerticalIcon from '@components/icons/EllipsisVertical.svg';
import { Popover } from '@components/core-ui/Popover';
import { MouseEvent, useState } from 'react';
import { Link } from 'react-router-dom';

import { getMenuItemClassName } from './helpers/getMenuItemClassName';
import { TAction } from '../../types/TAction';

const actionsWrapClassName = 'relative shrink-0 pb-[25px] pr-2.5';

const menuButtonClassName =
  'relative inline-flex h-8 w-8 items-center justify-center rounded-full bg-transparent text-[var(--color-text-muted)] hover:text-[var(--color-text-subtle)] focus:outline-none';

const popoverPanelClassName = 'right-0 top-full !mt-0 !overflow-visible !border-0 !bg-transparent !p-0 !shadow-none';

const menuListClassName =
  'm-0 block w-20 list-none overflow-hidden rounded-[5px] bg-[var(--color-surface)] p-0 shadow-[0_10px_15px_var(--color-shadow)]';

export const Actions = ({ actions }: { actions?: TAction[] }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  if (!actions) {
    return null;
  }

  return (
    <div className={actionsWrapClassName}>
      <button
        type="button"
        className={menuButtonClassName}
        onClick={(event: MouseEvent<HTMLButtonElement>) => {
          setAnchorEl(event.currentTarget);
        }}
      >
        <span className="sr-only">Open options</span>
        <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
      </button>
      <Popover
        open={anchorEl !== null}
        onClose={() => {
          setAnchorEl(null);
        }}
        anchorEl={anchorEl}
        panelClassName={popoverPanelClassName}
      >
        <ul className={menuListClassName}>
          {actions.map((action, index) => {
            return (
              <li
                key={index}
                className={getMenuItemClassName(action.className)}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (action.onClick) {
                    action.onClick();
                  }
                  setAnchorEl(null);
                }}
              >
                {action.link ? <Link to={action.link}>{action.label}</Link> : null}
                {!action.link ? action.label : null}
              </li>
            );
          })}
        </ul>
      </Popover>
    </div>
  );
};
